import axios from "axios";
import { getAuthToken } from "common-ui-components/accounts/framework/AuthTokenHandler";
import {redirectToSignIn} from "app/root/Root";
import { IAM_API_URL } from "./Config";

export const IAM_API = axios.create({
    baseURL: `${IAM_API_URL}`,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "ngrok-skip-browser-warning": "true",
    },
    withCredentials: true,
});

// Request interceptor to conditionally add Authorization header
IAM_API.interceptors.request.use(
    (config) => {
        // For other requests, add the Authorization header if token exists
        const token = getAuthToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        if (!config.params) {
            config.params = {};
        }
        config.params.productId = 1;
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor (optional, as you had before)
IAM_API.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.config) 
        {
            if (error.response) 
                ;
                //console.log(error.response.data);
            if (error.response && error.response.status === 401) 
            {
              redirectToSignIn();
            }
        }
        return Promise.reject(error);
    }
);